<div>
  @if (isClosable()) {
    <div class="flex justify-end m-0 p-0">
      <button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  }
  <div class="wrap-break-word">
    @if (data.message) {
      {{ data.message }}
    }
    @if (data.translationMessageKey) {
      {{ data.translationMessageKey | transloco: data.translationMessageParams }}
    }
  </div>
</div>
